import { IconTypes, UI, HStack } from '@genial/components';
import { Color, ColorTypes } from '@genial/design-tokens';
import { IconographyTypes } from '@genial/icons';

import { useGlobalAssetContext } from '../../contexts';

export type AssetCaptionType = {
  icon: IconographyTypes.Option;
  text: string;
  iconSize?: IconTypes.Sizes;
  iconColor: ColorTypes.Option;
  iconBackgroundColor?: ColorTypes.Option;
};

export const AssetCaptions = () => {
  const { selectedTab } = useGlobalAssetContext();

  const { captions } = selectedTab;

  if (!captions.length) {
    return <></>;
  }

  return (
    <HStack alignItems="center" space="inline.xxs" pt="stack.xxs">
      {captions.map((caption) => (
        <UI.Caption
          key={`caption-${caption.icon}`}
          testId={`caption-${caption.icon}`}
          icon={caption.icon}
          iconColor={Color[caption.iconColor]}
          {...(caption.iconBackgroundColor
            ? { iconBackgroundColor: Color[caption.iconBackgroundColor] }
            : {})}
          text={caption.text}
          iconSize={caption.iconSize || 'xs'}
        />
      ))}
    </HStack>
  );
};
